module.exports = __webpack_public_path__ + "static/media/Aviso de Privacidad PTM EN.5c68a6f1.pdf";